import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const MARGEN = 8; // separación del botón y de los bordes de la pantalla

// Menú ⋮ flotante. Se renderiza en <body> (portal) con position: fixed, así no lo recorta
// el overflow de la tabla, no cambia el alto de la fila y no genera scroll interno.
// Abre hacia abajo si cabe; si no, hacia arriba. Se ajusta para no salirse por los lados.
export default function AccionesMenu({ abierto, onToggle, onClose, label, children }) {
  const botonRef = useRef(null);
  const menuRef = useRef(null);
  const [pos, setPos] = useState(null);

  const ubicar = useCallback(() => {
    const b = botonRef.current?.getBoundingClientRect();
    const m = menuRef.current;
    if (!b || !m) return;
    const { offsetWidth: w, offsetHeight: h } = m;
    const vw = window.innerWidth, vh = window.innerHeight;
    const abajo = vh - b.bottom - MARGEN >= h || b.top - MARGEN < h; // sin espacio arriba tampoco: abajo
    const top = abajo ? b.bottom + 4 : b.top - h - 4;
    const left = Math.min(Math.max(MARGEN, b.right - w), vw - w - MARGEN); // alineado a la derecha del botón
    setPos({ top: Math.max(MARGEN, top), left, arriba: !abajo });
  }, []);

  useLayoutEffect(() => { if (abierto) ubicar(); else setPos(null); }, [abierto, ubicar]);

  useEffect(() => {
    if (!abierto) return undefined;
    const fuera = (e) => {
      if (menuRef.current?.contains(e.target) || botonRef.current?.contains(e.target)) return;
      onClose();
    };
    const tecla = (e) => { if (e.key === 'Escape') { onClose(); botonRef.current?.focus(); } };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', tecla);
    window.addEventListener('resize', ubicar);
    window.addEventListener('scroll', ubicar, true); // también el scroll de la tabla o del layout
    return () => {
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('keydown', tecla);
      window.removeEventListener('resize', ubicar);
      window.removeEventListener('scroll', ubicar, true);
    };
  }, [abierto, onClose, ubicar]);

  // Al elegir una acción el menú se cierra.
  const alHacerClic = (e) => { if (e.target.closest('button')) onClose(); };

  return (
    <>
      <button ref={botonRef} type="button" className="usuarios-kebab" aria-label={label} aria-haspopup="menu" aria-expanded={abierto} onClick={onToggle}>⋮</button>
      {abierto && createPortal(
        <div ref={menuRef} role="menu" aria-label={label} className={`usuarios-menu ${pos?.arriba ? 'usuarios-menu--arriba' : ''}`}
          style={{ position: 'fixed', top: pos?.top ?? -9999, left: pos?.left ?? -9999, visibility: pos ? 'visible' : 'hidden' }}
          onClick={alHacerClic}>
          {children}
        </div>,
        document.body,
      )}
    </>
  );
}
